import { Badge, Card, Flex, Heading } from '@radix-ui/themes';
import { CommonBackArrow } from 'components/common/buttons/back-arrow';
import { ErrorBoundary } from 'components/common/error-boundary';
import { JsonViewer } from 'components/common/json/json-viewer';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ISessionEventDetails } from 'lib_ts/interfaces/i-session-event';
import { ISessionSummary } from 'lib_ts/interfaces/i-session-summary';

interface IProps {
  session: ISessionSummary;
  event: ISessionEventDetails;
  onBack: () => void;
}

export const MachineSessionEventDetails = (props: IProps) => {
  const { onBack, session, event } = props;
  return (
    <ErrorBoundary identifier="MachineDetailsErrorsTab">
      <Flex
        direction="column"
        gap={RADIX.FLEX.GAP.MD}
        className={RADIX.VFLEX.GROW}
      >
        <Flex gap={RADIX.FLEX.GAP.SM} align="center">
          <CommonBackArrow onClick={onBack} />

          <Heading size="4">{t('admin.event-details')}</Heading>

          <Badge color={RADIX.COLOR.ACCENT}>{session.sessionID}</Badge>

          <Badge color={RADIX.COLOR.ACCENT}>{session.user}</Badge>
        </Flex>
        <Card>
          <JsonViewer value={event} />
        </Card>
      </Flex>
    </ErrorBoundary>
  );
};
